var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content-container"},[_vm._m(0),_c('div',{staticClass:"right-column"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Oops!")]),_c('h2',[_vm._v(_vm._s(_vm.message))]),_c('h3',[_vm._v("Error code: "+_vm._s(_vm.code))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-column"},[_c('img',{attrs:{"src":require("@/assets/imgs/404.svg")}})])
}]

export { render, staticRenderFns }